import { render, staticRenderFns } from "./MyOverlay.vue?vue&type=template&id=5d86c31b"
import script from "./MyOverlay.vue?vue&type=script&lang=js"
export * from "./MyOverlay.vue?vue&type=script&lang=js"
import style0 from "./MyOverlay.vue?vue&type=style&index=0&id=5d86c31b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports